import { FLOWABLE_BASE_URL } from "./config";

export const additionalData = {
	endpoints: {
		baseUrl: `${FLOWABLE_BASE_URL}`,
		action: `${FLOWABLE_BASE_URL}/action-api`,
		form: `${FLOWABLE_BASE_URL}/form-api`,
		idm: `${FLOWABLE_BASE_URL}/idm-api`,
		report: `${FLOWABLE_BASE_URL}/analytics-api`,
		template: `${FLOWABLE_BASE_URL}/template-api`,
		cmmn: `${FLOWABLE_BASE_URL}/cmmn-api`,
		process: `${FLOWABLE_BASE_URL}/process-api`,
		platform: `${FLOWABLE_BASE_URL}/platform-api`,
		//content: `${FLOWABLE_BASE_URL}/content-api`,
		content: `${FLOWABLE_BASE_URL}/cayuse-api`,
		dmn: `${FLOWABLE_BASE_URL}/dmn-api`,
		dataobject: `${FLOWABLE_BASE_URL}/dataobject-api`,
		cayuse: `/sp/api`
	}
};
